<template>
  <div>
    <a-tabs v-model:activeKey="activeKey" type="card" v-if="adminMode">
      <a-tab-pane key="application" tab="Aplicação">
        <a-row>
          <a-skeleton :loading="isLoading" active>
            <a-col :span="isDesktop ? 18 : 24" style="padding-right: 10px">
              <a-steps :current="current" type="navigation">
                <a-step v-for="item in vSteps" :key="item.title" :title="item.title" />
              </a-steps>
              <a-form
                ref="formRef"
                :model="vForm"
                @finish="onSubmit"
                :rules="rules"
                scrollToFirstError
                @finishFailed="handleFinishFailed"
                layout="vertical"
              >
                <div :class="$style.stepsContent">
                  <a-alert
                    v-if="readOnlyForm && application?.status == STATUS_PROCESSED"
                    :class="$style.editMode"
                    :message="`Você está em modo de visualização, a análise da sua aplicação já foi concluída, agora você pode baixar sua confirmação na tela principal!`"
                    type="success"
                    showIcon
                  >
                    <template #icon><smile-outlined /></template>
                  </a-alert>
                  <a-alert
                    v-if="readOnlyForm && (application?.status == STATUS_IN_REVIEW)"
                    :class="$style.editMode"
                    :message="`Você está em modo de visualização, a análise da sua aplicação esta em revisão, agora você pode baixar sua confirmação na tela principal!`"
                    type="success"
                    showIcon
                  >
                    <template #icon><smile-outlined /></template>
                  </a-alert>
                  <a-alert
                    v-if="readOnlyForm && application?.status == STATUS_PROCESSING"
                    :class="$style.editMode"
                    :message="`Você está em modo de visualização, sua aplicação ainda está em análise!`"
                    type="info"
                    showIcon
                  >
                    <template #icon><smile-outlined /></template>
                  </a-alert>
                  <a-alert
                    v-if="readOnlyForm && application?.status == STATUS_ERROR"
                    :class="$style.editMode"
                    :message="`OPS! Você possui alguns dados que estão faltando, contate nossa equipe para mais informações!`"
                    type="error"
                    showIcon
                  >
                    <template #icon><smile-outlined /></template>
                  </a-alert>

                  <div v-for="(step, index) in vSteps" :key="index">
                    <component v-if="index == current" :is="step.content"></component>
                  </div>
                </div>
                <div :class="$style.stepsAction">
                  <a-button
                    v-if="current > 0"
                    style="margin-left: 8px"
                    @click="prev"
                    html-type="submit"
                    >Anterior</a-button
                  >
                  <a-button
                    type="primary"
                    html-type="submit"
                    :loading="isLoadingSubmit"
                    :class="$style.saveButton"
                    v-if="showTriggers"
                  >
                    Salvar
                  </a-button>
                  <div v-else></div>
                  <a-button
                    v-if="current < vSteps.length - 1"
                    type="primary"
                    html-type="submit"
                    @click="next"
                    >Próximo</a-button
                  >
                </div>
              </a-form>
            </a-col>
            <a-col :span="6" style="padding-left: 10px" v-if="isDesktop">
              <a-col :span="24" v-show="isEditing">
                <NewProcessButton />
              </a-col>
              <RecentProcess
            /></a-col>
          </a-skeleton>
        </a-row>
      </a-tab-pane>
      <a-tab-pane key="annotation" tab="Anotações">
        <a-list item-layout="horizontal" :data-source="application?.annotations">
          <template #renderItem="{ item }">
            <a-list-item>
              <a-comment
                :author="item.from_system ? 'Sistema' : item.owner?.name"
                :avatar="
                  item.from_system
                    ? 'data:image/png;base64,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'
                    : 'https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png'
                "
              >
                <template #actions>
                  <span v-for="(action, index) in actions" :key="index">{{
                    action
                  }}</span>
                </template>
                <template #content>
                  <p>
                    {{ item.content }}
                  </p>
                </template>
                <template #datetime>
                  <a-tooltip
                    :title="moment(item.createdAt).format('YYYY-MM-DD HH:mm:ss')"
                  >
                    <span>{{ moment(item.createdAt).fromNow() }}</span>
                  </a-tooltip>
                </template>
              </a-comment>
            </a-list-item>
          </template>
        </a-list>
      </a-tab-pane>
    </a-tabs>
    <div v-else>
      <a-row>
        <a-skeleton :loading="isLoading" active>
          <a-col :span="isDesktop ? 18 : 24" style="padding-right: 10px">
            <a-steps :current="current" type="navigation">
              <a-step v-for="item in vSteps" :key="item.title" :title="item.title" />
            </a-steps>
            <a-form
              ref="formRef"
              :model="vForm"
              @finish="onSubmit"
              :rules="rules"
              scrollToFirstError
              @finishFailed="handleFinishFailed"
              layout="vertical"
            >
              <div :class="$style.stepsContent">
                <a-alert
                  v-if="readOnlyForm && (application?.status == STATUS_PROCESSED)"
                  :class="$style.editMode"
                  :message="`Você está em modo de visualização, a análise da sua aplicação já foi concluída, agora você pode baixar sua confirmação na tela principal!`"
                  type="success"
                  showIcon
                >
                  <template #icon><smile-outlined /></template>
                </a-alert>
                <a-alert
                  v-if="readOnlyForm && (application?.status == STATUS_IN_REVIEW)"
                  :class="$style.editMode"
                  :message="`Você está em modo de visualização, a análise da sua aplicação esta em revisão, agora você pode baixar sua confirmação na tela principal!`"
                  type="success"
                  showIcon
                >
                  <template #icon><smile-outlined /></template>
                </a-alert>
                <a-alert
                  v-if="readOnlyForm && application?.status == STATUS_PROCESSING"
                  :class="$style.editMode"
                  :message="`Você está em modo de visualização, sua aplicação ainda está em análise!`"
                  type="info"
                  showIcon
                >
                  <template #icon><smile-outlined /></template>
                </a-alert>
                <a-alert
                  v-if="readOnlyForm && application?.status == STATUS_ERROR"
                  :class="$style.editMode"
                  :message="`OPS! Você possui alguns dados que estão faltando, contate nossa equipe para mais informações!`"
                  type="error"
                  showIcon
                >
                  <template #icon><smile-outlined /></template>
                </a-alert>

                <div v-for="(step, index) in vSteps" :key="index">
                  <component v-if="index == current" :is="step.content"></component>
                </div>
              </div>
              <div :class="$style.stepsAction">
                <a-button
                  v-if="current > 0"
                  style="margin-left: 8px"
                  @click="prev"
                  html-type="submit"
                  >Anterior</a-button
                >
                <a-button
                  type="primary"
                  html-type="submit"
                  :loading="isLoadingSubmit"
                  :class="$style.saveButton"
                  v-if="showTriggers"
                >
                  Salvar
                </a-button>
                <div v-else></div>
                <a-button
                  v-if="current < vSteps.length - 1"
                  type="primary"
                  html-type="submit"
                  @click="next"
                  >Próximo</a-button
                >
              </div>
            </a-form>
          </a-col>
          <a-col :span="6" style="padding-left: 10px" v-if="isDesktop">
            <a-col :span="24" v-show="isEditing">
              <NewProcessButton />
            </a-col>
            <RecentProcess
          /></a-col>
        </a-skeleton>
      </a-row>
    </div>
  </div>
</template>
<script>
import { defineComponent, ref, createVNode } from "vue";
import { mapMutations, mapState, mapGetters, mapActions } from "vuex";
import NewProcessButton from "@/components/NewProcessButton/NewProcessButton";
import RecentProcess from "@/components/RecentProcess/RecentProcess";
import PersonalInformation from "@/components/Process/PersonalInformation/PersonalInformation";
import Travel from "@/components/Process/Travel/Travel";
//import Photo from "@/components/Process/Photo/Photo";
import Passport from "@/components/Process/Passport/Passport";
import Family from "@/components/Process/Family/Family";
import { isDesktop } from "@/utils/isAgent";
import router from "@/router";
import moment from "moment";
import {
  STATUS_PROCESSED,
  STATUS_PROCESSING,
  TRAVEL_SUGGESTION,
  STATUS_IN_REVIEW,
  STATUS_ERROR,
  NOT_REQUIRED_PHOTO,
} from "@/utils/Constants";
import { SmileOutlined } from "@ant-design/icons-vue";
import { Modal } from "ant-design-vue";
export default defineComponent({
  components: {
    RecentProcess,
    NewProcessButton,
    SmileOutlined,
  },
  setup() {
    const formRef = ref();

    const resetForm = () => {
      formRef.value.resetFields();
    };
    const current = ref(0);

    const next = async () => {
      await formRef.value.validate();
      current.value++;
    };

    const prev = async () => {
      await formRef.value.validate();
      current.value--;
    };

    return {
      current,
      formRef,
      next,
      prev,
      resetForm,
      labelCol: {
        span: 6,
      },
      wrapperCol: {
        span: 18,
      },
    };
  },
  data() {
    return {
      rules: [],
      steps: [],
      isEditing: false,
      isDesktop,
      STATUS_PROCESSING,
      STATUS_PROCESSED,
      STATUS_IN_REVIEW,
      STATUS_ERROR,
      NOT_REQUIRED_PHOTO,
      adminMode: false,
      activeKey: "application",
      actions: [],
      moment,
    };
  },
  computed: {
    ...mapState("application", ["vForm", "isLoadingSubmit", "isLoading", "application"]),
    ...mapGetters("user", ["isAdmin", "isModerator"]),
    ...mapGetters("application", ["shouldShowFamily", "readOnlyForm"]),
    showTriggers() {
      return (
        !this.application ||
        (this.application.status !== STATUS_PROCESSED && 
          this.application.status !== STATUS_IN_REVIEW &&
          this.application.status !== STATUS_PROCESSING)
      );
    },
    vSteps() {
      const steps = [
        {
          id: "personal_info",
          title: "Informações Pessoais",
          content: <PersonalInformation />,
          show: true,
        },
        {
          id: "travel",
          title: "Viagem",
          content: <Travel />,
          show: true,
        },
        {
          id: "passport",
          title: "Passaporte",
          content: <Passport />,
          show: true,
        },
        {
          id: "family",
          title: "Familia",
          content: <Family />,
          show: true,
        },
      ];

      /*if (!NOT_REQUIRED_PHOTO.includes(this.vForm.consul)) {
        steps.push({
          id: "photo",
          title: "Foto",
          content: <Photo />,
          show: true,
        });
      }*/
      return steps.filter((e) => e.show);
    },
  },
  methods: {
    ...mapMutations("application", ["setSaveFilledForm"]),
    ...mapActions("application", [
      "createApplication",
      "getApplication",
      "resetApplicationCache",
    ]),
    ...mapActions("system", ["getAllSuggestions"]),
    onCaptcha() {},
    async onSubmit() {
      if (this.showTriggers) {
        const data = this.vForm;

        const result = await this.createApplication(data);
        if (result && !this.isEditing) {
          router.push({ path: `/applications/${result.id}` });
          this.isEditing = true;
          Modal.success({
            title: "🎉 Cadastro finalizado!",
            content: createVNode("div", {}, [
              createVNode("p", {}, `Cadastro realizado com sucesso, ${this.user?.name || "visitante"}! 🎊`),
              createVNode("iframe", {
                src: "https://player.vimeo.com/video/1018685407",
                width: "100%",
                height: "400px",
                frameborder: "0",
                allow: "autoplay; fullscreen; picture-in-picture",
                style: "margin-top: 20px; border-radius: 10px;",
                allowfullscreen: true,
              }),
            ]),
            width: 600,
            style: { top: "100px" },
            onOk: async () => {
              console.log("Modal fechado após salvar!");
              router.push("/applications"); 
            },
          });
        }


        this.$message.success("Salvo com sucesso!");
        return result;
      }
    },
    async fillForm() {
      if (this.$route.params?.id) {
        this.isEditing = true;
        await this.getApplication(this.$route.params?.id);
      } else {
        this.resetApplicationCache();
      }
    },
  },
  async mounted() {
    this.adminMode = this.$route.query?.adminMode && (this.isModerator || this.isAdmin);
    this.fillForm();
    this.getAllSuggestions({ type: TRAVEL_SUGGESTION });
    const rules = {
      personal1GivenName: [
        {
          required: true,
          message: "Campo obrigatorio",
          trigger: "blur",
        },
      ],
      personal1Surname: [
        {
          required: true,
          message: "Campo obrigatorio",
          trigger: "blur",
        },
      ],
      personal1Doc: [
        {
          required: true,
          message: "Campo obrigatorio",
          trigger: "blur",
        },
      ],
      personal1Sex: [
        {
          required: true,
          message: "Campo obrigatorio",
          trigger: "change",
        },
      ],
      personal1HasUsedOtherName: [
        {
          required: true,
          message: "Campo obrigatorio",
          trigger: "change",
        },
      ],
      personal2Nationality: [
        {
          required: true,
          message: "Campo obrigatorio",
          trigger: "change",
        },
      ],
      nativeNamePersonal1: [
        {
          required: false,
          message: " ",
          trigger: "blur",
        },
      ],
      maritalStatusPersonal1: [
        {
          required: true,
          message: "Selecione um opção",
          trigger: "change",
        },
      ],
      personal2HoldOtherNationality: [
        {
          required: true,
          message: "Selecione um opção",
          trigger: "change",
        },
      ],
      personal2IsPermanentResidentOtherCountry: [
        {
          required: true,
          message: "Selecione um opção",
          trigger: "change",
        },
      ],
      cityPersonal1: [
        {
          required: false,
          message: " ",
          trigger: "blur",
        },
      ],
      provincePersonal1: [
        {
          required: false,
          message: " ",
          trigger: "blur",
        },
      ],
      regionPersonal1: [
        {
          required: true,
          message: "Selecione um região",
          trigger: "blur",
        },
      ],
      personal1BirthCity: [
        {
          required: true,
          message: "Campo obrigatório",
          trigger: "blur",
        },
      ],
      passportDocumentNumber: [
        {
          required: true,
          message: "Campo obrigatório",
          trigger: "blur",
        },
      ],
      passportAuthorityDocumentCity: [
        {
          required: true,
          message: "Campo obrigatório",
          trigger: "blur",
        },
      ],
      personal1Marital: [
        {
          required: true,
          message: "Campo obrigatório",
          trigger: "blur",
        },
      ],
      workPreviousWereYouPreviouslyEmployed: [
        {
          required: true,
          message: "Campo obrigatório",
          trigger: "blur",
        },
      ],
      workPreviousHaveAttendedAnyEducational: [
        {
          required: true,
          message: "Campo obrigatório",
          trigger: "blur",
        },
      ],
      workPresentOccupation: [
        {
          required: true,
          message: "Campo obrigatório",
          trigger: "blur",
        },
      ],
      passportAuthorityDocumentState: [
        {
          required: true,
          message: "Campo obrigatório",
          trigger: "blur",
        },
      ],
      passportHavePassportStolen: [
        {
          required: true,
          message: "Campo obrigatório",
          trigger: "blur",
        },
      ],
      personal1BirthState: [
        {
          required: true,
          message: "Campo obrigatório",
          trigger: "blur",
        },
      ],
      personal1BirthCountry: [
        {
          required: true,
          message: "Campo obrigatório",
          trigger: "blur",
        },
      ],

      addressAndPhoneCountry: [
        {
          required: true,
          message: "Campo obrigatório",
          trigger: "blur",
        },
      ],
      addressAndPhoneAddressLine1: [
        {
          required: true,
          message: "Campo obrigatório",
          trigger: "change",
        },
      ],
      travelHasMadePlans: [
        {
          required: true,
          message: "Campo obrigatório",
          trigger: "change",
        },
      ],
      travelWhoPaying: [
        {
          required: true,
          message: "Campo obrigatório",
          trigger: "change",
        },
      ],
      travelCompanionsHasPersonTraveling: [
        {
          required: true,
          message: "Campo obrigatório",
          trigger: "change",
        },
      ],
      addressAndPhoneCity: [
        {
          required: true,
          message: "Campo obrigatório",
          trigger: "change",
        },
      ],
      addressAndPhonePrimaryPhoneNumber: [
        {
          required: true,
          message: "Campo obrigatório",
          trigger: "blur",
        },
      ],
      addressAndPhoneEmailAddress: [
        {
          required: true,
          message: "Campo obrigatório",
          trigger: "blur",
        },
      ],
      previousHasTraveledOthersCountries: [
        {
          required: true,
          message: "Campo obrigatório",
          trigger: "blur",
        },
      ],
      passportDocumentType: [
        {
          required: true,
          message: "Campo obrigatório",
          trigger: "blur",
        },
      ],
      passportAuthorityDocumentCountry: [
        {
          required: true,
          message: "Campo obrigatório",
          trigger: "blur",
        },
      ],
      passportAuthorityDocumentRegion: [
        {
          required: true,
          message: "Campo obrigatório",
          trigger: "blur",
        },
      ],
      travelCompanionsYesGroupName: [
        {
          required: true,
          message: "Campo obrigatório",
          trigger: "blur",
        },
      ],
      previousUSTravelHasFiledImmigrantPetitionExplain: [
        {
          required: true,
          message: "Campo obrigatório",
          trigger: "blur",
        },
      ],
      previousUSTravelHaveBeenRefusedAdmissionExplain: [
        {
          required: true,
          message: "Campo obrigatório",
          trigger: "blur",
        },
      ],
      previousUSTravelHaveIssuedBeenUSCancelled: [
        {
          required: true,
          message: "Campo obrigatório",
          trigger: "blur",
        },
      ],
      previousUSTravelHaveIssuedBeenUSLost: [
        {
          required: true,
          message: "Campo obrigatório",
          trigger: "blur",
        },
      ],
      previousUSTravelHaveIssuedBeenUSbeenTenPrinted: [
        {
          required: true,
          message: "Campo obrigatório",
          trigger: "blur",
        },
      ],
      previousUSTravelHaveIssuedBeenUSApplyingSameCountry: [
        {
          required: true,
          message: "Campo obrigatório",
          trigger: "blur",
        },
      ],
      previousUSTravelHaveIssuedBeenUSApplyingSameVisa: [
        {
          required: true,
          message: "Campo obrigatório",
          trigger: "blur",
        },
      ],
      previousUSTravelHaveIssuedBeenUSDateLastVisaNumber: [
        {
          required: true,
          message: "Campo obrigatório",
          trigger: "blur",
        },
      ],
      previousUSTravelHaveIssuedBeenUSCancelledExplain: [
        {
          required: true,
          message: "Campo obrigatório",
          trigger: "blur",
        },
      ],
      previousUSTravelHaveIssuedBeenUSLostExplain: [
        {
          required: true,
          message: "Campo obrigatório",
          trigger: "blur",
        },
      ],
      previousUSTravelHaveBeenUSHoldDriveLicense: [
        {
          required: true,
          message: "Campo obrigatório",
          trigger: "blur",
        },
      ],
      previousUSTravelHaveIssuedBeenUSLostYear: [
        {
          required: true,
          message: "Campo obrigatório",
          trigger: "blur",
        },
      ],
      addressAndPhoneState: [
        {
          required: true,
          message: "Campo obrigatório",
          trigger: "change",
        },
      ],
      consul: [
        {
          required: true,
          message: "Selecione um consulado",
          trigger: "blur",
        },
      ],
      surnamePersonal1: [
        {
          required: true,
          message: "Sobrenome não pode ser vazio",
          trigger: "blur",
        },
      ],
      passportTypePassport: [
        {
          required: true,
          message: "Please input Activity name",
          trigger: "blur",
        },
      ],
      passportNumberPassport: [
        {
          required: true,
          message: "Please select Activity zone",
          trigger: "blur",
        },
      ],
      travelDocumentPassport: [
        {
          required: true,
          message: "Please select Activity zone",
          trigger: "blur",
        },
      ],
      cityPassport: [
        {
          required: true,
          message: "Please select Activity zone",
          trigger: "blur",
        },
      ],
      provincePassport: [
        {
          required: true,
          message: "Please select Activity zone",
          trigger: "blur",
        },
      ],
      countryPassport: [
        {
          required: true,
          message: "Please select Activity zone",
          trigger: "blur",
        },
      ],
      travelNoIntentAddressStayZipCode: [
        {
          required: true,
          message: "Campo obrigatório",
          trigger: "blur",
        },
        {
          min: 5,
          max: 10,
          message: "Zip Code deve ter 9 digitos",
          trigger: "change",
        },
      ],
      travelWhoPayingPersonNoAddressZipCode:
        this.vForm?.travelWhoPayingPersonNoAddressCountry == "BRLZ"
          ? [
              {
                min: 8,
                max: 8,
                message: "CEP deve ter 8 digitos",
                trigger: "change",
              },
            ]
          : [],
      previousUSTravelHaveBeenUS: [
        {
          required: true,
          message: "Campo obrigatório",
          trigger: "change",
        },
      ],
      previousUSTravelHaveIssuedBeenUS: [
        {
          required: true,
          message: "Campo obrigatório",
          trigger: "change",
        },
      ],
      previousUSTravelHaveBeenRefusedAdmission: [
        {
          required: true,
          message: "Campo obrigatório",
          trigger: "change",
        },
      ],
      previousUSTravelHasFiledImmigrantPetition: [
        {
          required: true,
          message: "Campo obrigatório",
          trigger: "change",
        },
      ],
      travelNoIntentLengthStayType: [
        {
          required: true,
          message: "Campo obrigatório",
          trigger: "change",
        },
      ],
      travelNoIntentLengthStay: [
        {
          required: true,
          message: "Campo obrigatório",
          trigger: "change",
        },
      ],
      travelNoIntentAddressStayLine1: [
        {
          required: true,
          message: "Campo obrigatório",
          trigger: "change",
        },
      ],
      travelNoIntentAddressStayCity: [
        {
          required: true,
          message: "Campo obrigatório",
          trigger: "change",
        },
      ],
      travelCompanionsIsInGroup: [
        {
          required: true,
          message: "Campo obrigatório",
          trigger: "change",
        },
      ],
    };

    this.rules = rules;
  },
  watch: {
    $route: {
      handler: function () {
        this.fillForm();
      },
      deep: true,
      immediate: true,
    },
  },
});
</script>

<style module src="./style.scss" lang="scss"></style>
